import { Link } from "react-router-dom";
import { useAppContext } from '../config/context';

const TransLink = ({ to = "/", children, ...props }) => {
    const { lang } = useAppContext();

    const translateRoute = (path) => {
       const cleanPath = path.startsWith("/") ? path.slice(1) : path;

        if (lang === "es") {
            return `/${cleanPath}`;
        }

        return `/${lang}/${cleanPath}`;
    };


    return (
        <Link to={translateRoute(to)} {...props}>
            {children}
        </Link>
    );
};

export default TransLink;
